module.exports = __webpack_public_path__ + "img/danger-square.4ad32f00.svg";